// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"679":"efeab0d0893ab0a7b3a6","936":"01c8ff4de5e8b10798c8"}[chunkId] + ".js";
};